import {renderElement} from "../../utils/common";
import {ActionUrl, CLOSE_CLASS_NAME, CONFIRM_REMOVE_CLASS_NAME, GROUP_CLASS_NAME, REMOVE_GROUP_CLASS_NAME, ROOT_CLASS_NAME} from "../constants";
import {getConfirmModalTemplate, getDefaultTemplate} from "../template";
import {Api} from "../../api/api";
import {showToast} from "../../toast";

/**
 * Функционал для удаления группы с метками
 *
 * @class RemoveGroup
 */
class RemoveGroup {
  private element: HTMLElement;
  private confirmModalElement: ChildNode | null;
  private id: number;
  private parent: HTMLElement | null;

  private url: string = ActionUrl.REMOVE_GROUP_URL;
  private api: Api = new Api();

  constructor() {
    this.onDocumentClick = this.onDocumentClick.bind(this);

    document.addEventListener(`click`, this.onDocumentClick);
  }

  private init(): void {
    if (this.element.dataset.id) {
      this.id = +this.element.dataset.id;
      this.parent = this.element.closest(`.${ROOT_CLASS_NAME}`);

      this.confirmModalClickHandler = this.confirmModalClickHandler.bind(this);

      this.renderConfirmModal();
    }
  }

  /**
   * Генерация модального окна подтверждения удаления
   *
   * @memberof RemoveGroup
   */
  private renderConfirmModal(): void {
    this.confirmModalElement = renderElement(document.body, getConfirmModalTemplate());

    this.confirmModalElement?.addEventListener(`click`, this.confirmModalClickHandler);
  }

  /**
   * Удаления окна подтверждения
   *
   * @memberof RemoveGroup
   */
  private removeModal(): void {
    this.confirmModalElement?.remove();

    this.confirmModalElement?.removeEventListener(`click`, this.confirmModalClickHandler);
  }

  /**
   * Удаление группы меток с разметки и закрытие окна подтверждения
   *
   * @memberof RemoveGroup
   */
  private removeGroup(): void {
    this.element.remove();

    this.removeModal();

    if (this.parent?.childElementCount === 0) {
      renderElement(this.parent, getDefaultTemplate());
    }
  }

  /**
   * Отправка запроса на удаление группы меток
   *
   * @memberof RemoveGroup
   */
  private async fetchRemoveGroup(): Promise<void> {
    const {code, answer} = await this.api.customQuery(`${this.url}?id=${this.id}`, {});

    if (code === 200) {
      this.removeGroup();
    } else {
      showToast(answer.text);
    }
  }

  /**
   * Слушатель на окне подтверждения удаления. Удаление окна в случае нажатия на кнопку "Закрыть" и отправка запроса на удаление если нажата кнопка "Удалить"
   *
   * @memberof RemoveGroup
   */
  async confirmModalClickHandler(evt: Event): Promise<void> {
    const target: HTMLElement = evt.target as HTMLElement;

    switch (true) {
      case target.classList.contains(CLOSE_CLASS_NAME):
        this.removeModal();
        break;
      case target.classList.contains(CONFIRM_REMOVE_CLASS_NAME):
        await this.fetchRemoveGroup();
        break;
    }
  }

  onDocumentClick({target}) {
    if (target.classList.contains(REMOVE_GROUP_CLASS_NAME)) {
      this.element = target.closest(`.${GROUP_CLASS_NAME}`);

      this.init();
    }
  }
}

export {RemoveGroup};
